import { ArrowUUpRight, Check, EnvelopeOpen } from "@phosphor-icons/react";

import type { CreatedTemplate, TemplateType } from "common/types";

export const TEMPLATE_SORTING_ORDERS: Record<
  string,
  {
    label: string;
    sortFn: (template1: CreatedTemplate, template2: CreatedTemplate) => number;
  }
> = {
  latest: {
    label: "Latest",
    sortFn: (template1, template2) =>
      template2.created_at - template1.created_at,
  },
  oldest: {
    label: "Oldest",
    sortFn: (template1, template2) =>
      template1.created_at - template2.created_at,
  },
  sentAsc: {
    label: "Sent ascending",
    sortFn: (template1, template2) =>
      template1.metrics.sent - template2.metrics.sent,
  },
  sentDesc: {
    label: "Sent descending",
    sortFn: (template1, template2) =>
      template2.metrics.sent - template1.metrics.sent,
  },
  acceptedAsc: {
    label: "Accepted ascending",
    sortFn: (template1, template2) =>
      template2.metrics.accepted - template1.metrics.accepted,
  },
  acceptedDesc: {
    label: "Accepted descending",
    sortFn: (template1, template2) =>
      template1.metrics.accepted - template2.metrics.accepted,
  },
  repliedAsc: {
    label: "Replied ascending",
    sortFn: (template1, template2) =>
      template1.metrics.replies - template2.metrics.replies,
  },
  repliedDesc: {
    label: "Replied descending",
    sortFn: (template1, template2) =>
      template2.metrics.replies - template1.metrics.replies,
  },
} as const;

const COMMON_SORTING_ORDERS = ["latest", "oldest", "sentAsc", "sentDesc"];
export const TEMPLATE_TYPE_SORTING_ORDERS: Record<
  TemplateType,
  (keyof typeof TEMPLATE_SORTING_ORDERS)[]
> = {
  NOTE_TEMPLATE: [...COMMON_SORTING_ORDERS, "acceptedAsc", "acceptedDesc"],
  INMAIL_TEMPLATE: [...COMMON_SORTING_ORDERS, "repliedAsc", "repliedDesc"],
  MESSAGE_TEMPLATE: [...COMMON_SORTING_ORDERS, "repliedAsc", "repliedDesc"],
} as const;

export const TEMPLATE_METRICS = [
  {
    getLabel: () => "Sent",
    icon: EnvelopeOpen,
    getValue: ({ metrics }: CreatedTemplate) => metrics.sent,
  },
  {
    getLabel: (templateType: TemplateType) =>
      templateType === "NOTE_TEMPLATE" ? "Accepted" : "Replied",
    icon: ArrowUUpRight,
    getValue: ({ type, metrics }: CreatedTemplate) =>
      type === "NOTE_TEMPLATE" ? metrics.accepted : metrics.replies,
  },
  {
    getLabel: () => "Success rate",
    icon: Check,
    getValue: ({ type, metrics }: CreatedTemplate) => {
      const value =
        type === "NOTE_TEMPLATE" ? metrics.accepted : metrics.replies;
      if (!metrics.sent) {
        return "0%";
      }
      return `${value ? Math.round((value / metrics.sent) * 100) : 0}%`;
    },
  },
] as const;
